import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { UntypedFormControl } from '@angular/forms'
import { Subject } from 'rxjs'
import { languages } from '../../constants'

@Component({
  selector: 'app-language-select',
  templateUrl: './language-select.component.html',
  styleUrls: ['./language-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LanguageSelectComponent implements OnInit, OnDestroy {
  @Input() items = languages.map((l) => ({ code: l['1'], name: l.name }))

  @Input() ctrl = new UntypedFormControl()
  @Input() inline = false
  @Input() label = $localize`Language`
  @Input() showBlankItem = true
  @Input() multiple = false

  destroy$ = new Subject<void>()
  constructor() {}

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.destroy$.next()
    this.destroy$.complete()
  }
}
